// CategoryList.js

import React from 'react';
import CategoryItem from './CategoryItem';
import './CategoryList.css';

const CategoryList = ({ categories, fetchCategories, onEdit }) => { // 1. Añadir onEdit aquí
  return (
    <div className="category-list-container">
      {categories.length > 0 ? (
        categories.map((category) => (
          <CategoryItem 
            key={category._id} 
            category={category} 
            fetchCategories={fetchCategories} 
            onEdit={onEdit} // 2. Pasar onEdit a CategoryItem
          />
        ))
      ) : (
        <p>No hay categorías disponibles.</p>
      )}
    </div>
  );
};

export default CategoryList;
